import React from 'react'

import styles from './_ellipsis.module.scss'

type EllipsisProps = {
  /** Optional prop to add a test id to the Ellipsis for QA testing */
  qaTestId?: string
}

const Ellipsis = ({
  qaTestId = 'ellipsis',
}: EllipsisProps): React.JSX.Element => {
  return (
    <span
      className={styles.ellipsis}
      data-testid='ellipsis-component'
      qa-test-id={qaTestId}
    >
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  )
}

export default Ellipsis
